import { Component, ViewChild } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TelephonyService } from '../../../services/telephony.service';
import { PhoneNumberInfo } from '../../../models/twilio-phone-number-info';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PhoneSettingsService } from '../../../services/phone-settings.service';
import { UserPhoneNumbersPageEventsService } from '../../../events/user-integrations-page-events.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-phone-number-selection',
  standalone: true,
  imports: [
    MatDividerModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatFormFieldModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCheckboxModule,
    NgFor,
    NgIf,
    MatProgressSpinnerModule
  ],
  templateUrl: './phone-number-selection-dialog.component.html',
  styleUrl: './phone-number-selection-dialog.component.scss'
})
export class PhoneNumberSelectionDialogComponent {
  twilioPhoneNumbers: PhoneNumberInfo[] = [];
  displayedColumns: string[] = ['Number', 'Locality', 'Region', 'Country', 'Action'];
  dataSource!: MatTableDataSource<PhoneNumberInfo>;
  countries: string[] = ['ALL'];
  regions: string[] = ['ALL'];
  countrySelectedValue: FormControl = new FormControl('ALL');
  regionSelectedValue: FormControl = new FormControl('ALL');
  tollFreeSelectedValue: FormControl = new FormControl(false);
  isLoading: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<PhoneNumberSelectionDialogComponent>,
    private telephonyService: TelephonyService,
    private phoneSettingsService: PhoneSettingsService,
    private userPhoneNumberPageEventService: UserPhoneNumbersPageEventsService,
    private snackBar: MatSnackBar
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit() {
    this.getPhoneNumbersList();
    this.subscribeToCountrySelectValueChange();
  }

  applyFilter() {
    this.dataSource.data = this.twilioPhoneNumbers.filter(phone => {
      return phone.isoCountry && phone.isoCountry.includes(this.countrySelectedValue.value == 'ALL' ? '' : this.countrySelectedValue.value)
        && (phone.region && phone.region.includes(this.regionSelectedValue.value == 'ALL' ? '' : this.regionSelectedValue.value) || this.regionSelectedValue.value == 'ALL')
        && phone.tollFree == this.tollFreeSelectedValue.value;
    });
  }

  applyTollFreeFilter() {
    this.dataSource.data = this.twilioPhoneNumbers.filter(phone => {
      return phone.isoCountry && phone.isoCountry.includes(this.countrySelectedValue.value == 'ALL' ? '' : this.countrySelectedValue.value)
        && phone.tollFree == this.tollFreeSelectedValue.value;
    });
  }

  getPhoneNumbersList() {
    this.isLoading = true;

    this.telephonyService.fetchAvailablePhoneNumbers().subscribe(phoneNumbers => {
      this.twilioPhoneNumbers = phoneNumbers;
      this.dataSource.data = this.twilioPhoneNumbers;

      this.countries = [... this.countries, ... new Set(this.twilioPhoneNumbers.flatMap(phone => phone.isoCountry))];
      this.regions = [... this.regions, ... new Set(this.twilioPhoneNumbers.flatMap(phone => phone.region))];
      this.isLoading = false;
    });
  }

  onBuyClicked(phoneNumber: PhoneNumberInfo) {
    this.isLoading = true;
    
    this.phoneSettingsService.purchasePhoneNumber(phoneNumber.phoneNumber).subscribe({
      next: () => {
        this.userPhoneNumberPageEventService.OnPhoneNumbersRefreshEvent.emit();
        this.dialogRef.close(phoneNumber);
        this.openSnackBar('Phone number purchased successfully');
        this.isLoading = false;
      },
      error: () => {
        alert('Server error, contact support');
        this.isLoading = false;
      }
    });
  }

  private subscribeToCountrySelectValueChange() {
    this.countrySelectedValue.valueChanges.subscribe(value => {
      if (value == 'ALL') {
        this.regions = ['ALL', ...new Set(this.twilioPhoneNumbers.map(phone => phone.region))];
      }
      else
        this.regions = ['ALL', ...new Set(this.twilioPhoneNumbers.filter(phone => phone.isoCountry == value).map(phone => phone.region))];
    });
  }
   
  openSnackBar(message: string) {
    this.snackBar.open(message, 'close', { duration: 5000 });
  }
}